import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from '@coveord/plasma-mantine';
import { Controller } from 'react-hook-form';
export var RHFCheckbox = function RHFCheckbox(_0) {
    var control = _0.control, externalOnBlur = _0.onBlur, externalOnChange = _0.onChange, restProps = _object_without_properties(_0, [
        "control",
        "onBlur",
        "onChange"
    ]);
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: restProps.name,
        render: function render(_0) {
            var _ref = _0.field, value = _ref.value, onBlur = _ref.onBlur, onChange = _ref.onChange, restField = _object_without_properties(_ref, [
                "value",
                "onBlur",
                "onChange"
            ]), fieldState = _0.fieldState;
            var _fieldState_error;
            return /*#__PURE__*/ _jsx(Checkbox, _object_spread(_object_spread_props(_object_spread({
                checked: value
            }, restField), {
                error: (_fieldState_error = fieldState.error) === null || _fieldState_error === void 0 ? void 0 : _fieldState_error.message,
                onBlur: function onBlur1(event) {
                    externalOnBlur === null || externalOnBlur === void 0 ? void 0 : externalOnBlur(event);
                    onBlur();
                },
                onChange: function onChange1(event) {
                    externalOnChange === null || externalOnChange === void 0 ? void 0 : externalOnChange(event);
                    onChange(event);
                }
            }), restProps));
        }
    });
};
RHFCheckbox.Group = Checkbox.Group;

//# sourceMappingURL=RHFCheckbox.js.map